import { throttle } from '@gbds/core/src/ts/utils'
import { AuthStorageKeys } from '../config/auth-enumerations'

export enum InactivityEvents {
	inactiveUser = 'gbpe-inactive-user',
}

export enum InactivityStorageKeys {
	userSignedOut = 'gbpe.inactivity.sign.out',
	customTimeOut = 'gbpe.auth.user.inactive.timeout',
}

export class InactivityTracker {
	private _timer: number
	private _timerId
	private _eventHandler: () => void
	constructor(timeout: number) {
		this._timer = timeout
		this._eventHandler = this.syncTimer.bind(this)

		this.tracker()
	}

	/**
	 * reset Timer function
	 */
	resetTimer(): void {
		clearTimeout(this._timerId)
		this._timerId = setTimeout(this.dispatchUserInactive, this._timer)
	}

	/**
	 * Sync timer function
	 */
	syncTimer(): void {
		this.emitActiveUser()
		this.resetTimer()
	}

	/**
	 * Dispatch storage event
	 */
	emitActiveUser(): void {
		localStorage.setItem(AuthStorageKeys.userActive, 'true')
		localStorage.removeItem(AuthStorageKeys.userActive)
	}

	/**
	 * dispatch event when the timeout has been reached
	 */
	dispatchUserInactive(): void {
		if (window.gbpe.config.locale === 'ko-KR') {
			window.dispatchEvent(new CustomEvent(InactivityEvents.inactiveUser))
		}
		console.log(`Inactivity Logout Disabled for This Region`)
	}

	/**
	 * Sets up events to track in order to measure inactivity
	 */
	tracker(): void {
		window.addEventListener('load', throttle(this._eventHandler.bind(this), 1000))
		window.addEventListener('mousemove', throttle(this._eventHandler.bind(this), 1000))
		window.addEventListener('mousedown', throttle(this._eventHandler.bind(this), 1000))
		window.addEventListener('scroll', throttle(this._eventHandler.bind(this), 1000), true)
		window.addEventListener('keydown', throttle(this._eventHandler.bind(this), 1000))
		window.addEventListener('click', throttle(this._eventHandler.bind(this), 1000))
	}
}
